import styled from 'styled-components';
import { Box } from '@rsos/base-components';

export const TranscriptContent = styled(Box)`
  gap: 16px;
  height: 100%;
  min-height: 60%;
`;
